module.exports = __webpack_public_path__ + "img/icon_--_snapshots.fd83c888.png";